export const SET_ACTIVE_ROUTE = 'SET_ACTIVE_ROUTE'
export const SET_ACTIVE_PROPERTY = 'SET_ACTIVE_PROPERTY'
export const REQUEST_ROUTES_PENDING = 'REQUEST_ROUTES_PENDING'
export const REQUEST_ROUTES_SUCCESS = 'REQUEST_ROUTES_SUCCESS'
export const REQUEST_ROUTES_FAILED = 'REQUEST_ROUTES_FAILED'

export const GET_DRIVERS_PENDING = 'GET_DRIVERS_PENDING'
export const GET_DRIVERS_SUCCESS = 'GET_DRIVERS_SUCCESS'
export const GET_DRIVERS_FAILED = 'GET_DRIVERS_FAILED'
export const SET_ACTIVE_DRIVER = 'SET_ACTIVE_DRIVER'

export const UPDATE_ADDRESSES_PENDING = 'UPDATE_ADDRESSES_PENDING'
export const UPDATE_ADDRESSES_SUCCESS = 'UPDATE_ADDRESSES_SUCCESS'
export const UPDATE_ADDRESSES_FAILED = 'UPDATE_ADDRESSES_FAILED'

export const UPDATE_CUSTOMERS_PENDING = 'UPDATE_CUSTOMERS_PENDING'
export const UPDATE_CUSTOMERS_SUCCESS = 'UPDATE_CUSTOMERS_SUCCESS'
export const UPDATE_CUSTOMERS_FAILED = 'UPDATE_CUSTOMERS_FAILED'

export const SET_LOG_ENTRIES = 'SET_LOG_ENTRIES'

export const GET_ROUTE_PROPERTIES_SUCCESS = 'GET_ROUTE_PROPERTIES_SUCCESS'
export const FILTER_PROPERTIES_SUCCESS = 'FILTER_PROPERTIES_SUCCESS'

export const GET_ROUTE_SUCCESS = 'GET_ROUTE_SUCCESS'
export const GET_ROUTE_PENDING = 'GET_ROUTE_PENDING'
export const GET_ROUTE_FAILED = 'GET_ROUTE_FAILED'

export const SAVE_ROUTE_SUCCESS = 'SAVE_ROUTE_SUCCESS'
export const SAVE_ROUTE_PENDING = 'SAVE_ROUTE_PENDING'
export const SAVE_ROUTE_FAILED = 'SAVE_ROUTE_FAILED' 

export const NEW_PROPERTY_SUCCESS = 'NEW_PROPERTY_SUCCESS'
export const NEW_PROPERTY_PENDING = 'NEW_PROPERTY_PENDING'
export const NEW_PROPERTY_FAILED = 'NEW_PROPERTY_FAILED'

export const DEL_PROPERTY_SUCCESS = 'DEL_PROPERTY_SUCCESS'
export const DEL_PROPERTY_PENDING = 'DEL_PROPERTY_PENDING'
export const DEL_PROPERTY_FAILED = 'DEL_PROPERTY_FAILED'

export const SHOW_ROUTE_EDITOR = 'SHOW_ROUTE_EDITOR'

export const SHOW_ROUTE = 'SHOW_ROUTE'

export const SET_ACTIVE_TRACTOR = 'SET_ACTIVE_TRACTOR'

export const GET_VEHICLE_TYPES_PENDING = "GET_VEHICLE_TYPES_PENDING"
export const GET_VEHICLE_TYPES_SUCCESS = "GET_VEHICLE_TYPES_SUCCESS"
export const GET_VEHICLE_TYPES_FAILED = "GET_VEHICLE_TYPES_FAILED"

export const ROUTE_DATA_PENDING = 'ROUTE_DATA_PENDING'
export const ROUTE_DATA_SUCCESS = 'ROUTE_DATA_SUCCESS'
export const ROUTE_DATA_FAILED = 'ROUTE_DATA_FAILED'

export const GET_ITEMS_PENDING = 'GET_ITEMS_PENDING'
export const GET_TRACTORS_SUCCESS = 'GET_TRACTORS_SUCCESS'
export const GET_ITEMS_FAILED = 'GET_ITEMS_FAILED'

export const SET_ACTIVE_VEHICLE_TYPE = 'SET_ACTIVE_VEHICLE_TYPE'

export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_USER_PENDING = 'GET_USER_PENDING'
export const SET_USER_FAILED = 'GET_USER_FAILED'

export const TIMER_IS_RUNNING = "TIMER_IS_RUNNING"
export const GET_WORK_TYPES_SUCCESS = 'GET_WORK_TYPES_SUCCESS'
export const GET_WORK_TYPES_PENDING = 'GET_WORK_TYPES_PENDING'
export const GET_WORK_TYPES_FAILED = 'GET_WORK_TYPES_FAILED'
export const GET_PRICING_TEMPLATES_SUCCESS = 'GET_PRICING_TEMPLATES_SUCCESS'

export const SET_WORK_TYPE = 'SET_WORK_TYPE'

export const SHOW_MODAL = "SHOW_MODAL"
export const HIDE_MODAL = "HIDE_MODAL"

export const TEMP_ITEM = "TEMP_ITEM"

export const ACTIVE_LOG_ENTRY = "ACTIVE_LOG_ENTRY"
export const USER_LOGOUT = 'USER_LOGOUT'

export const IS_LOADING = 'IS_LOADING'

export const COLOR_MODE = 'COLOR_MODE'

export const SET_ACTIVE_PRICING_TEMPLATE = 'SET_ACTIVE_PRICING_TEMPLATE'

export const UPDATE_FAILED = 'UPDATE_FAILED'
export const UPDATE_PENDING = 'UPDATE_PENDING'
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS'
